import React from "react";
import { SiteVisit, SiteVisitPropertyData, SiteVisitPropertyUpdateData } from "../../core/api/models/sitevisit";

interface ScheduleSiteVisitHeaderProps {
    currentSelectedPropertyDetail: SiteVisitPropertyUpdateData;
    onClose: () => void;
    id: string;
    propertyData: {
        [key: string]: SiteVisitPropertyData;
    } | undefined
    singleProperty: any;
    onScheduleEditClick: (params: any, id: string) => void;
    siteVisit: SiteVisit;
  }
  
export   function ScheduleSiteVisitHeader({ currentSelectedPropertyDetail,
    onClose,
    propertyData,
    onScheduleEditClick,
    id,
    singleProperty,
    siteVisit }: ScheduleSiteVisitHeaderProps) {
    return (
      <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-9">
        <div className="row align-items-center">
          <div className="col-auto" onClick={onClose}>
            <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
          </div>
          <div className="col-auto font-base font-weight-bold">
            Schedule a site visit
          </div>
          <div className="col-auto">
            <div className="font-xxs font-weight-semibold px-2 bg-orange-light py-1 rounded text-gray-800">
              Pending Visit Schedule
            </div>
          </div>
          <div className="col-auto mt-md-0 mt-1 ml-auto">
            {!singleProperty && <span className="bg-white d-inline-block mr-2">
              <button
                type="button"
                className="btn btn-outline-secondary px-5 font-normal font-weight-bold py-2 rounded"
                style={{ height: "40px" }}
                onClick={() => onScheduleEditClick(siteVisit, id)}
              >
                Edit
              </button>
            </span>}
            <button
              type="submit"
              className="btn btn-primary px-3 font-normal font-weight-bold py-2 rounded"
              style={{ height: "40px" }}
              disabled={
                !!currentSelectedPropertyDetail?.currentSelectedPropertyId ||
                Object.keys(propertyData || {})?.length !==
                siteVisit?.propertyIds?.length
              }
            >
              Preview & Continue
            </button>
          </div>
        </div>
      </div>
    );
  }
  